export const StaticImage = (filename) => {
  return (
    window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + filename
  );
};
